var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgLandscape = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1.33em",
  height: "1em",
  viewBox: "0 0 32 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#9B9B9B",
  fillRule: "evenodd",
  d: "M29.969 0H2.03C.911 0 0 .878 0 1.959V22.04C0 23.123.91 24 2.031 24H29.97c1.123 0 2.03-.877 2.03-1.959V1.96C32 .878 31.093 0 29.969 0m0 1.959v14.25l-4.003-3.512a1.565 1.565 0 0 0-2.103.05l-4.053 3.906-7.992-9.203a1.557 1.557 0 0 0-2.321-.014L2.03 15.799V1.96h27.94zm-8.634 5.144c0-1.49 1.25-2.695 2.793-2.695s2.792 1.205 2.792 2.695c0 1.488-1.25 2.693-2.792 2.693-1.543 0-2.793-1.205-2.793-2.693"
})));
export default SvgImgLandscape;